import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { Media, Collapse } from 'reactstrap'
import { supportActions } from '../../redux/actions'
import './Faq.scss'

export default function FaqAccordion({ faqs }) {
  const baseCssClass = 'pt-2 pl-1'

  const dispatch = useDispatch()
  const handleFaq = (id, keyword) => {
    dispatch(supportActions.setActiveSuggestion(id, keyword))
  }

  return (
    <div role="region" aria-label="FAQ accordion">
      {faqs.length > 0 ? (
        (Array.isArray(faqs) ? faqs : []).map((faq, index) => (
          <Media className="mb-3" key={faq.faqId || index}>
            <Media
              body
              style={{ cursor: 'pointer' }}
              onClick={() => handleFaq(faq.faqId, faq.keyword)}
              className={faq.isOpen ? `${baseCssClass} faq-active pb-3` : `${baseCssClass}`}
              role="button"
              tabIndex={0}
              aria-expanded={faq.isOpen}
              aria-controls={`faq-content-${faq.faqId || index}`}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  handleFaq(faq.faqId, faq.keyword)
                }
              }}
            >
              <Media
                heading
                className={faq.isOpen ? 'faq__question faq__question-active' : 'faq__question'}
                tag="h3"
                id={`faq-heading-${faq.faqId || index}`}
              >
                {faq.sortOrder}
                {'. '}
                <FormattedMessage id={faq.question} />
              </Media>
              <div className="ml-3 mr-3">
                <Collapse
                  isOpen={faq.isOpen}
                  id={`faq-content-${faq.faqId || index}`}
                  role="region"
                  aria-labelledby={`faq-heading-${faq.faqId || index}`}
                >
                  <FormattedHTMLMessage id={faq.response} />
                </Collapse>
              </div>
            </Media>
          </Media>
        ))
      ) : (
        <h4 className="my-3">
          <FormattedMessage id="global.label.FAQSuggestion" />
        </h4>
      )}
    </div>
  )
}

FaqAccordion.propTypes = {
  faqs: PropTypes.array.isRequired,
}
